import React, { useState } from "react"
import { Col, Form, Row } from "antd"
import { useTranslation } from "react-i18next"
import { useSelector, useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"

// selectors
import { updatePassword } from "store/user"
// hooks
import useFormErrors from "hooks/useAntdFormErrors"
// ui
import { Text, Title } from "ui/Typography"
import { CustomInput } from "ui/Input"
import { CustomForm } from "ui/Form"
import layoutStyles from "layoutsV2/pro/ProSettingsLayout/Index.module.css"
import styles from "./LoginAndSecurity.module.css"
import { ActionButtons } from "ui/ActionButtons"
// components
import { ChangeEmailPhoneForm } from "./ChangeEmailPhoneForm"
import { AccountManagement } from "../ProSettings/AccountManagement"
// utils
import { GoogleConnect } from "./GoogleConnect"
import { AppleConnect } from "./AppleConnect"
import { notification } from "ui/Notification"
import { validateStrongPassword } from "ui/auth/utils"
import { Icon } from "ui/Icon"

export const LoginAndSecurity = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [newPassword, setNewPassword] = useState(null)
  const [currentPassword, setCurrentPassword] = useState(null)
  const [form] = Form.useForm()
  useFormErrors(form)

  const { loading } = useSelector((state) => state.auth)

  const handleNavigateBack = () => navigate(-1)

  const handleUpdatePassword = ({ current_password, password }) => {
    dispatch(
      updatePassword({
        current_password,
        password,
        password_confirmation: password
      })
    ).then(() => {
      form.resetFields()
      setNewPassword(null)
      setCurrentPassword(null)
      notification.success({
        message: t("password.changed")
      })
    })
  }

  return (
 
      <div className={layoutStyles.hasWideMaxWidth} style={{ margin: "0 auto" }}>
        <Row gutter={[72, 12]} align="top" justify="space-between">
          <Col span={24} md={11}>
            <div className={`flex items-center ${styles.backIconWrapper}`}>
              <button onClick={handleNavigateBack} className={styles.backIcon} type="button">
                <Icon width={16} height={16} type="feather" name="ChevronLeft" color="currentColor" />
              </button>
              <Title level={3} className="mb-s">
                {t("settings.login_security", { defaultValue: "Login & Security" })}
              </Title>
            </div>
          </Col>
          <Col span={24} md={13}>
            <Title level={3} className="mb-s">
              {t("settings.account_management", { defaultValue: "Account Management" })}
            </Title>
          </Col>
        </Row>
        <Row gutter={[72, 24]} align="top" justify="space-between">
          <Col span={24} md={11}>
            <ChangeEmailPhoneForm />
            <CustomForm
              form={form}
              name="settings-login-security"
              layout="vertical"
              validateMessages={{ required: t("form_validation.cannot_be_blank") }}
              initialValues={{
                password: "",
                current_password: ""
              }}
              onFinish={handleUpdatePassword}
            >
              <Form.Item label={t("change_password.current_password")} name="current_password" required={true} rules={[{ required: true }]}>
                <CustomInput.Password placeholder="Enter Password" onChange={(e) => setCurrentPassword(e.target.value)} />
              </Form.Item>
              <Form.Item
                label={t("change_password.new_password")}
                name="password"
                required
                rules={[
                  {
                    validator: (_, value) => validateStrongPassword(value, t)
                  }
                ]}
              >
                <CustomInput.Password placeholder="8+ characters" onChange={(e) => setNewPassword(e.target.value)} />
              </Form.Item>
              <div className="flex gap-s mt-4xl mb-6xl">
                <ActionButtons
                  onCancelClick={handleNavigateBack}
                  loading={loading}
                  disabled={!(currentPassword?.length > 0 && newPassword?.length >= 8)}
                />
              </div>
              <div className="my-xl">
                <Text fw={500}>{t("settings.connect_accounts")}</Text>
              </div>
              <Row gutter={[24, 12]}>
                {/* <Col xl={8}>
                  <FacebookConnect />
                </Col> */}
                <Col className={styles.connectCardCol}>
                  <GoogleConnect />
                </Col>
                <Col className={styles.connectCardCol}>
                  <AppleConnect />
                </Col>
              </Row>
            </CustomForm>
          </Col>
          <Col span={24} md={13}>
            <AccountManagement />
          </Col>
        </Row>
      </div>
  
  )
}
